module.exports = __webpack_public_path__ + "img/monitoringdescription4.dc145857.png";